import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function PerformanceModeToggle({ mode, onEdit, onPractice, onPerform }) {
  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={(e, next) => {
        if (!next || next === mode) return;
        if (next === "perform" && typeof onPerform === "function") onPerform();
        if (next === "practice" && typeof onPractice === "function") onPractice();
        if (next === "edit" && typeof onEdit === "function") onEdit();
      }}
      sx={{
        border: '1px solid #9dbf9e',
        borderRadius: '4px',
        overflow: 'hidden',
        '& .MuiToggleButtonGroup-grouped': {
          textTransform: 'none',
          fontWeight: 500,
          minWidth: 70,
          px: 1.2,
          py: 0.55,
          fontSize: '0.78rem',
          lineHeight: 1.4,
          border: 'none',
          color: '#2f4f2f',
          backgroundColor: 'white',
          transition: 'background-color 120ms, color 120ms',
          '&:not(:last-of-type)': { borderRight: '1px solid #c6d9c8' },
          '&:hover': { backgroundColor: '#f3faf4' },
          '&.Mui-selected': {
            backgroundColor: '#e2f5e9',
            color: '#0b5d28',
            fontWeight: 600,
            '&:hover': { backgroundColor: '#d2eedc' }
          }
        }
      }}
    >
      <ToggleButton value="edit">Write</ToggleButton>
      <ToggleButton value="practice">Practice</ToggleButton>
      <ToggleButton value="perform">Perform</ToggleButton>
    </ToggleButtonGroup>
  );
}